import React from 'react';
import { useNavigate } from 'react-router';
import { getRequestBodySchema } from '../../../../../common/src/routes/openApiSchemaHelpers';
import { useTranslate } from '../../../mixins/translate/translate';
import {
    Content,
    EditPanel,
    EditPanelButtons,
    EditPanelCell,
    EditPanelRow,
    Panel,
    PanelBody,
    PanelButton,
    Topbar,
    TopbarCrumbActive,
    TopbarLeft,
    Tray,
} from '../../elements';
import { ValidatingJsonSchemaForm } from '../../validatingComponents/ValidatingJsonSchemaForm';
import { ValidatingEditPanelSaveButton, ValidatingFilterDropdownWithUrl, ValidatingFormInputText } from '../../validatingElements';
import { EditInspectionStandardSelect } from '../InspectionStandardSelect';

export function InspectionFormAddEdit(props: { params: { id?: string } }) {
    const t = useTranslate();
    const navigate = useNavigate();
    const handleSavedOrCancelled = () => navigate('/settings/inspection-forms');

    return (
        <>
            <Topbar>
                <TopbarLeft>
                    <TopbarCrumbActive title={t(props.params.id ? 'common.editItem' : 'common.addItem', t('inspectionForms.form'))} icon="fa-cogs" />
                </TopbarLeft>
            </Topbar>
            <Content>
                <Tray>
                    <Panel small>
                        <PanelBody noPadding>
                            <ValidatingJsonSchemaForm
                                createSchema={getRequestBodySchema('/api/settings/inspection-forms', 'post')}
                                updateSchema={getRequestBodySchema('/api/settings/inspection-forms/{inspectionFormId}', 'post')}
                                createUrl={'/api/settings/inspection-forms'}
                                updateUrl={`/api/settings/inspection-forms/${props.params.id}`}
                                itemUrl={`/api/settings/inspection-forms/${props.params.id}`}
                                id={props.params.id}
                                onSubmitted={handleSavedOrCancelled}
                            >
                                <EditPanel>
                                    <EditPanelRow>
                                        <EditPanelCell rowCount={6}>
                                            <ValidatingFormInputText name="name" topLabel={t('common.name')} />
                                        </EditPanelCell>

                                        <EditPanelCell rowCount={6}>
                                            <ValidatingFilterDropdownWithUrl
                                                name="inspectionTemplateId"
                                                topLabel={t('inspectionForms.template')}
                                                placeholder={t('common.selectItem', t('inspectionForms.template'))}
                                                url={'/api/settings/inspection-templates'}
                                            />
                                        </EditPanelCell>
                                    </EditPanelRow>

                                    <EditInspectionStandardSelect />
                                </EditPanel>

                                <EditPanelButtons footer>
                                    <PanelButton text={t('common.cancel')} onClick={handleSavedOrCancelled} />
                                    <ValidatingEditPanelSaveButton />
                                </EditPanelButtons>
                            </ValidatingJsonSchemaForm>
                        </PanelBody>
                    </Panel>
                </Tray>
            </Content>
        </>
    );
}
